import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import createReactClass from 'create-react-class';
import Carousel from 'nuka-carousel';

import css from 'styles/components/common/desktopSlider.scss';

const makeDecorators = (arrowStyle, testId) => [
  {
    position: 'CenterLeft',
    component: ({ currentSlide, previousSlide }) => {
      const prevButtonClasses = cn(css.prevArrow, {
        [css.arrow]: arrowStyle === 'swatch',
        [css.borderedArrow]: arrowStyle === 'recos',
        [css.disabled]: currentSlide === 0
      });
      return <button
        type="button"
        className={prevButtonClasses}
        onClick={previousSlide}
        data-test-id={testId('desktopSliderPrevious')}/>;
    }
  },
  {
    position: 'CenterRight',
    component: ({ currentSlide, slideCount, slidesToScroll, nextSlide }) => {
      const nextButtonClasses = cn(css.nextArrow, {
        [css.arrow]: arrowStyle === 'swatch',
        [css.borderedArrow]: arrowStyle === 'recos',
        [css.disabled]: currentSlide === slideCount || (currentSlide + slidesToScroll) === slideCount
      });
      return <button
        type="button"
        className={nextButtonClasses}
        onClick={nextSlide}
        data-test-id={testId('desktopSliderNext')}/>;
    }
  }
];

const DesktopSlider = createReactClass({
  mixins: [Carousel.ControllerMixin],
  // Work around bug where carousel does not always resize when images are loaded
  resizeCarousel() {
    this.refs['desktop-slider-carousel']?.setDimensions();
  },

  asyncResizeCarousel() {
    setTimeout(this.resizeCarousel);
  },

  render() {
    const {
      decorators: maybeDecorators,
      arrowStyle, children, framePadding, slidesToScroll, slidesToShow,
      slideWidth, wrapAround
    } = this.props;
    const { testId } = this.context;
    const decorators = maybeDecorators || makeDecorators(arrowStyle, testId);
    return <div onLoad={this.asyncResizeCarousel}>
      <Carousel
        ref="desktop-slider-carousel"
        decorators={decorators}
        slidesToShow={slidesToShow}
        slidesToScroll={slidesToScroll}
        slideWidth={slideWidth}
        dragging={false}
        autoplay={false}
        autoplayInterval={5000}
        framePadding={framePadding}
        wrapAround={wrapAround}>
        {children}
      </Carousel>
    </div>;
  }
});

DesktopSlider.propTypes = {
  slidesToShow: PropTypes.number.isRequired,
  slidesToScroll: PropTypes.number.isRequired,
  framePadding: PropTypes.string,
  wrapAround: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};

DesktopSlider.defaultProps = {
  arrowStyle: 'swatch',
  framePadding: '0 30px',
  slideWidth: 1,
  wrapAround: false
};

DesktopSlider.contextTypes = {
  testId: PropTypes.func
};

export default DesktopSlider;
